<template>
	<div id="pageRoot">

		<!-- TEXTS ----------------------------------------------------------------------------------------------------->
		<div class="basicItem01" id="potGroup">
			<img id="potSVG" src="/pages/img/sordo/svgPage64Pot.svg">
			<p class="textBase" id="potText">
				MACETA
			</p>
		</div>

		<label class="checkMarkContainer-a" style="left: 291px; top: 115.52px; position: absolute;">Una Sílaba
		<input type="checkbox"
        ref="a1" 
        v-on:change="saveOption('radios', 'a1')" 
        :onload="loadOption('radios', 'a1')"
        />
		<span class="checkmark-a"></span>
		</label>
		<label class="checkMarkContainer-a" style="left: 355px; top: 115.52px; position: absolute;">Dos Sílabas
		<input type="checkbox"
        ref="a2" 
        v-on:change="saveOption('radios', 'a2')" 
        :onload="loadOption('radios', 'a2')"
        />
		<span class="checkmark-a"></span>
		</label>
		<label class="checkMarkContainer-a" style="left: 418px; top: 115.52px; position: absolute;">Tres Sílabas
		<input type="checkbox"
        ref="a3" 
        v-on:change="saveOption('radios', 'a3')" 
        :onload="loadOption('radios', 'a3')"
        />
		<span class="checkmark-a"></span>
		</label>
		<label class="checkMarkContainer-a" style="left: 481px; top: 115.52px; position: absolute;">Cuatro Sílabas
		<input type="checkbox"
        ref="a4" 
        v-on:change="saveOption('radios', 'a4')" 
        :onload="loadOption('radios', 'a4')"
        />
		<span class="checkmark-a"></span>
		</label>
		<label class="checkMarkContainer-a" style="left: 544px; top: 115.52px; position: absolute;">Cinco Sílabas
		<input type="checkbox"
        ref="a5" 
        v-on:change="saveOption('radios', 'a5')" 
        :onload="loadOption('radios', 'a5')"
        />
		<span class="checkmark-a"></span>
		</label>
		<label class="checkMarkContainer-a" style="left: 608px; top: 115.52px; position: absolute;">Seis Sílabas
		<input type="checkbox"
        ref="a6" 
        v-on:change="saveOption('radios', 'a6')" 
        :onload="loadOption('radios', 'a6')"
        />
		<span class="checkmark-a"></span>
		</label>

		<saved-input v-bind:page="$parent.page" v-bind:type="$parent.type" number=1 id="inputField01"/>

		<div class="basicItem01" id="ballGroup">
			<img id="ballSVG" src="/pages/img/sordo/svgPage65Ball.svg">
			<p class="textBase" id="ballText">
				PELOTA
			</p>
		</div>

		<label class="checkMarkContainer-a" style="left: 291px; top: 323.52px; position: absolute;">Una Sílaba
		<input type="checkbox"
        ref="b1" 
        v-on:change="saveOption('radios', 'b1')" 
        :onload="loadOption('radios', 'b1')"
        />
		<span class="checkmark-a"></span>
		</label>
		<label class="checkMarkContainer-a" style="left: 355px; top: 323.52px; position: absolute;">Dos Sílabas
		<input type="checkbox"
        ref="b2" 
        v-on:change="saveOption('radios', 'b2')" 
        :onload="loadOption('radios', 'b2')"
        />
		<span class="checkmark-a"></span>
		</label>
		<label class="checkMarkContainer-a" style="left: 418px; top: 323.52px; position: absolute;">Tres Sílabas
		<input type="checkbox"
        ref="b3" 
        v-on:change="saveOption('radios', 'b3')" 
        :onload="loadOption('radios', 'b3')"
        />
		<span class="checkmark-a"></span>
		</label>
		<label class="checkMarkContainer-a" style="left: 481px; top: 323.52px; position: absolute;">Cuatro Sílabas
		<input type="checkbox"
        ref="b4" 
        v-on:change="saveOption('radios', 'b4')" 
        :onload="loadOption('radios', 'b4')"
        />
		<span class="checkmark-a"></span>
		</label>
		<label class="checkMarkContainer-a" style="left: 544px; top: 323.52px; position: absolute;">Cinco Sílabas
		<input type="checkbox"
        ref="b5" 
        v-on:change="saveOption('radios', 'b5')" 
        :onload="loadOption('radios', 'b5')"
        />
		<span class="checkmark-a"></span>
		</label>
		<label class="checkMarkContainer-a" style="left: 608px; top: 323.52px; position: absolute;">Seis Sílabas
		<input type="checkbox"
        ref="b6" 
        v-on:change="saveOption('radios', 'b6')" 
        :onload="loadOption('radios', 'b6')"
        />
		<span class="checkmark-a"></span>
		</label>

		<saved-input v-bind:page="$parent.page" v-bind:type="$parent.type" number=2 id="inputField02"/>

		<div class="basicItem01" id="roofGroup">
			<img id="roofSVG" src="/pages/img/sordo/svgPage64Roof.svg">
			<p class="textBase" id="roofText">
				TECHO
			</p>
		</div>

		<label class="checkMarkContainer-a" style="left: 291px; top: 539.12px; position: absolute;">Una Sílaba
		<input type="checkbox"
        ref="c1" 
        v-on:change="saveOption('radios', 'c1')" 
        :onload="loadOption('radios', 'c1')"
        />
		<span class="checkmark-a"></span>
		</label>
		<label class="checkMarkContainer-a" style="left: 355px; top: 539.12px; position: absolute;">Dos Sílabas
		<input type="checkbox"
        ref="c2" 
        v-on:change="saveOption('radios', 'c2')" 
        :onload="loadOption('radios', 'c2')"
        />
		<span class="checkmark-a"></span>
		</label>
		<label class="checkMarkContainer-a" style="left: 418px; top: 539.12px; position: absolute;">Tres Sílabas
		<input type="checkbox"
        ref="c3" 
        v-on:change="saveOption('radios', 'c3')" 
        :onload="loadOption('radios', 'c3')"
        />
		<span class="checkmark-a"></span>
		</label>
		<label class="checkMarkContainer-a" style="left: 481px; top: 539.12px; position: absolute;">Cuatro Sílabas
		<input type="checkbox"
        ref="c4" 
        v-on:change="saveOption('radios', 'c4')" 
        :onload="loadOption('radios', 'c4')"
        />
		<span class="checkmark-a"></span>
		</label>
		<label class="checkMarkContainer-a" style="left: 544px; top: 539.12px; position: absolute;">Cinco Sílabas
		<input type="checkbox"
        ref="c5" 
        v-on:change="saveOption('radios', 'c5')" 
        :onload="loadOption('radios', 'c5')"
        />
		<span class="checkmark-a"></span>
		</label>
		<label class="checkMarkContainer-a" style="left: 608px; top: 539.12px; position: absolute;">Seis Sílabas
		<input type="checkbox"
        ref="c6" 
        v-on:change="saveOption('radios', 'c6')" 
        :onload="loadOption('radios', 'c6')"
        />
		<span class="checkmark-a"></span>
		</label>

		<saved-input v-bind:page="$parent.page" v-bind:type="$parent.type" number=3 id="inputField03"/>

		<!-- TEXTS ----------------------------------------------------------------------------------------------------->

		<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
		<div class="pageSVG">
			<img src="/pages/img/sordo/svgPage69Background.svg" class="pageElement" style=" width: 100%; height: auto;">
		</div>
		<span class="footer-page footer-write"></span>
		<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
	</div>
</template>
<style scoped>
.textBase 
{
margin:0px;
z-index: 3;
font-family: Open Sans, sans-serif;
font-style: normal;
font-weight: normal;
font-size: 24px;
line-height: 33px;
color: #000000;
}

#text01 
{
/* Luego, en cada cartel, escribe otra palabra que tenga la misma cantidad de sílabas */
position: absolute;
width: 615px;
height: 70px;
left: 66.74px;
top: 40px;
z-index: 10;

font-weight: 600;
font-size: 26px;
line-height: 35px;

color: #FFFFFF;
}

#inputField01
{
font-size: 28px;
position: absolute;
width: 156px;
height: 39px;
left: 745px;
top: 114px;
z-index: 3;
background-color: #D2D1C2;
}
#inputField02
{
font-size: 28px;
position: absolute;
width: 156px;
height: 39px;
left: 745px;
top: 324px;
z-index: 3;
background-color: #D2D1C2;
}
#inputField03
{
font-size: 28px;
position: absolute;
width: 156px;
height: 39px;
left: 745px;
top: 548px;
z-index: 3;
background-color: #D2D1C2;
}

#potGroup
{
position: absolute;
width: 136px;
height: 169px;
left: 86px;
top: 32px;
}
#potSVG
{
position: absolute;
left: 0px;
top: 3px;
width: 113.36px;
height: 121.43px;
}
#potText 
{
position: absolute;
width: 136px;
height: 41px;
left: 0px;
top: 128px;

font-size: 33px;
line-height: 45px;
text-align: center;
}

#ballGroup
{
position: absolute;
width: 136px;
height: 171px;
left: 86px;
top: 251px;
}
#ballSVG 
{
position: absolute;
left: 3px;
top: 0px;
width: 129.48px;
height: 124.01px;
}
#ballText
{
position: absolute;
width: 136px;
height: 41px;
left: 0px;
top: 130px;

font-size: 33px;
line-height: 45px;
text-align: center;
}

#roofGroup
{
position: absolute;
width: 203.6px;
height: 177px;
left: 50px;
top: 479px;
}
#roofSVG
{
position: absolute;
width: 203.6px;
height: 129.34px;
left: 0%;
top: 0%;
}
#roofText
{
position: absolute;
width: 136px;
height: 41px;
left: 36px;
top: 136px;

font-size: 33px;
line-height: 45px;
text-align: center;
}
</style>
<script>
  export default {
    methods:{
      dbId(name, option){
        return `${this.$parent.pageID()}-${name}-${option}`
      },
      async loadOption(name, option) {
        var id = this.dbId(name, option);

        var value = await this.$db.options.get({
        id: id,
        }).catch(function(error){
        console.log("error getting option" + error);
        });
        if (value === undefined) return;
        console.log(value);

        this.$refs[option].checked=value.option;

        console.log("option loaded: " + id + ", " + value.option);
      },
      saveOption(name, option) {
        var id = this.dbId(name, option);
        var value = this.$refs[option].checked;

        this.$db.options.put({
              id: id,
              option: value
          }).catch(function(error){
              console.log("error saving option" + error);
          });

        console.log("option saved: " + id + ", " + value);
      }
    },
    mounted(){

    }
  }
</script>